// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7e3f48f7","441":"3719f064","597":"2a7d77e8","787":"91222865"}[chunkId] + ".chunk.js";
};